import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/core';

export const ContainerElement = styled.div`
    margin-right: -${getSpacingToken('50')}px;
    margin-top: -${getSpacingToken('50')}px;
    text-align: center;
`;
